{
	"sent": {
		"title": "Sent Conference",
		"tooltip": "Cash conference sent to the financial back office."
	},
	"pending": {
		"title": "Pending Conference",
		"tooltip": "Cash conference pending to be sent to the financial back office."
	},
	"openPdv": "Open PDVs",
	"openTable": "Outdoor tables"
}
